import { render, staticRenderFns } from "./CreateRubric.vue?vue&type=template&id=5142552e&scoped=true&"
import script from "./CreateRubric.vue?vue&type=script&lang=js&"
export * from "./CreateRubric.vue?vue&type=script&lang=js&"
import style0 from "./CreateRubric.vue?vue&type=style&index=0&id=5142552e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5142552e",
  null
  
)

export default component.exports